import _ from 'lodash';
import React from 'react';
import * as oauth from '../oauth';
import { EnforceGoogleSignin } from './enforce-google-signin';
import { googleOauth } from './context';

export const OauthStatusVerification = ({ children, ...rest }) => {
  const { googleOauthStatus } = React.useContext(googleOauth) || {};
  const [error] = React.useState(null);
  const isSigned = oauth.isSignedIn();

  React.useEffect(() => {
  }, [googleOauthStatus, isSigned]);
  const verificationRenderer = _.cond([
    [oauth.isSignedIn, () => children],
    [_.stubTrue, () => (<EnforceGoogleSignin />)],
  ]);
  const render = _.isFunction(children) ? children : verificationRenderer;

  return render({ isSigned, error, ...rest });
};
